'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChangeLanguageAction = exports.changeLanguageAction = undefined;

var _lodash = require('lodash.isundefined');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Change language action creator
 * @param {string} id The new language id to set as the active language throughout the website
 * @returns {ChangeLanguageActionType} The action to be dispatched
 */


/**
 * The change language action shape
 */
var changeLanguageAction = exports.changeLanguageAction = function changeLanguageAction(id) {
  return {
    type: _constants.LANGUAGE_CHANGED,
    id: id
  };
};

/**
 * Tests if a given action is of type LANGUAGE_CHANGED
 * @param {Object} action The action being processed
 * @returns {Boolean} True if the action is of type LANGUAGE_CHANGED and the language id is defined. False otherwise
 */

var isChangeLanguageAction = exports.isChangeLanguageAction = function isChangeLanguageAction(action) {
  return action.type === _constants.LANGUAGE_CHANGED && !(0, _lodash2.default)(action.id);
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/language-common/dist/main/actions.js
// module id = 260
// module chunks = 0